import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { Box, Link, Paper, Skeleton, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import FileUpload from "~/components/FileUpload";
import { useProjectDetails } from "../hooks/useProjectDetails";
import { useLatestWpr } from "./hooks/useLatestWpr";
import { useStepClickHandler } from "./hooks/useStepClickHandler";
import { StepChildProps } from "./WPRStepper";

// function timeout(ms: number) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, ms);
//   });
// }

export const WPRStepThree = ({
  setActiveStep,
  setStepChangeClickedType,
  stepChangeClickedType,
  setShowStepper,
}: StepChildProps & {
  setShowStepper: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [uploadedExcel, setUploadedExcel] = React.useState<File | null>(null);
  const qc = useQueryClient();
  const { wprFile, wprFileUrl, uploadModifiedWpr } = useLatestWpr();
  const { id } = useProjectDetails();
  const { t } = useTranslation();
  const handleUpload = React.useCallback(async () => {
    // TODO CHECK
    if (!uploadedExcel) {
      setShowStepper(false);
      return Promise.resolve();
    }
    return uploadModifiedWpr({
      projectId: id,
      file: { data: uploadedExcel, fileName: uploadedExcel?.name ?? "" },
    }).then(() => {
      void qc.invalidateQueries([id, "wpr-list"]);
      setShowStepper(false);
    });
  }, [id, qc, setShowStepper, uploadModifiedWpr, uploadedExcel]);
  const handleBackStep = React.useCallback(() => {}, []);

  useStepClickHandler({
    nextStepFn: handleUpload,
    setActiveStep,
    backStepFn: handleBackStep,
    stepChangeClickedType,
    setStepChangeClickedType,
    loadingText: t("WPR:loadingExcel"),
  });

  if (!wprFile || !wprFileUrl) return <Skeleton />;

  return (
    <Box
      sx={{
        display: "flex",
        gap: "15px",
        minHeight: "300px",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Link href={wprFileUrl} download={wprFile.fileName}>
          <Paper
            sx={{
              display: "flex",
              // flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "16px",
              gap: "10px",
              backgroundColor: "#fafafa",
              margin: "auto",
            }}
          >
            <FilePresentIcon fontSize="large" />
            <Typography variant="body2">{wprFile.fileName}</Typography>
            <FileDownloadIcon fontSize="large" />
          </Paper>
        </Link>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography>{t("WPR:stepThreeChangesMade")}</Typography>
        <FileUpload
          options={{
            onDrop: (x: File[]) => {
              setUploadedExcel(x[0]);
            },
            accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

            maxFiles: 1,
          }}
        />
      </Box>
      {uploadedExcel ? (
        <Link
          href={URL.createObjectURL(uploadedExcel)}
          download={uploadedExcel.name}
        >
          <Paper
            sx={{
              display: "flex",
              // flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "16px",
              gap: "10px",
              backgroundColor: "#fafafa",
              margin: "auto",
            }}
          >
            <FilePresentIcon fontSize="large" />
            <Typography variant="body2">{uploadedExcel.name}</Typography>
            <FileDownloadIcon fontSize="large" />
          </Paper>
        </Link>
      ) : null}
    </Box>
  );
};
